import React from "react";
import { Text, Flex, Box, Icon, Link, useColorModeValue } from "@chakra-ui/react";
import { FaPhone, FaEnvelope, FaClock, FaLinkedin, FaFacebook } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import config from "../../config";

// Styles for the Burger Menu (kept as-is, not used here)
const styles = {
  bmBurgerButton: {
    position: "absolute",
    width: "36px",
    height: "30px",
    right: "16px",
    top: "25px",
  },
  bmBurgerBars: {
    background: "#373a47",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "24px",
    width: "24px",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
  },
  bmMenu: {
    background: "#373a47",
    padding: "2.5em 1.5em 0",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
  },
  bmItem: {
    display: "inline-block",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

function NavbarTopFirst() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 704px)" });
  const primaryColor = useColorModeValue("blue.500", "teal.500");
  const secondaryColor = useColorModeValue("teal.500", "blue.500");

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={1001}
      bg="blue.600"
      color="white"
      fontSize="14px"
      width="100%"
      height="40px"
    >
      <Flex
        justifyContent="space-between"
        maxWidth="80%"
        mx="auto"
        alignItems="center"
        height="100%"
        display={isTabletOrMobile ? "none" : "flex"}
      >
        {/* LEFT SIDE */}
        <Flex alignItems="center" gap={6}>
          <Flex alignItems="center" gap={2}>
            <Icon as={FaClock} color="white" />
            <Text color="white">24/7 Support Services</Text>
          </Flex>

          <Flex alignItems="center" gap={2}>
            <Icon as={FaEnvelope} color="white" />
            <Link
              href="mailto:partners@orivanta.ai"
              color="white"
              _hover={{ textDecoration: "underline", color: "white" }}
            >
              partners@orivanta.ai
            </Link>
          </Flex>
        </Flex>

        {/* RIGHT SIDE */}
        <Flex alignItems="center" gap={6}>
          <Flex alignItems="center" gap={2}>
            <Icon as={FaPhone} color="white" />
            <Link
              href="tel:9473421755"
              color="white"
              _hover={{ textDecoration: "underline", color: "white" }}
            >
              9473421755
            </Link>
          </Flex>

          <Link
            href="https://www.linkedin.com/company/orivanta-ai/"
            isExternal
            ml={2}
          >
            <Icon
              as={FaLinkedin}
              boxSize={5}
              color="white"
              _hover={{ color: "blue.300" }}
            />
          </Link>

          <Link href="https://www.facebook.com/" isExternal ml={2}>
            <Icon
              as={FaFacebook}
              boxSize={5}
              color="white"
              _hover={{ color: "blue.300" }}
            />
          </Link>
        </Flex>
      </Flex>
    </Box>
  );
}

export default NavbarTopFirst;
